import { generateMobileSourcesForPicture } from '@farmersdog/corgi-x';
import { ImageMarquee } from './ImageMarquee';
import styles from './ImageMarqueeMobile.module.css';

import { ImageMarqueeItemsOne, ImageMarqueeItemsTwo } from './data';

export const ImageMarqueeMobile = () => {
  const assetsForFirstMarquee = ImageMarqueeItemsOne.map((item, index) => ({
    ...item,
    sources: generateMobileSourcesForPicture(item.sources),
    index,
  }));

  const assetsForSecondMarquee = ImageMarqueeItemsTwo.map((item, index) => ({
    ...item,
    sources: generateMobileSourcesForPicture(item.sources),
    index,
  }));

  return (
    <div className={styles.root}>
      <ImageMarquee
        direction="left"
        ariaLabel="First marquee of dogs with The Farmers Dog"
        className={styles.firstImageMarquee}
        items={assetsForFirstMarquee}
      />
      <ImageMarquee
        direction="right"
        ariaLabel="Second marquee of dogs with The Farmers Dog"
        items={assetsForSecondMarquee}
      />
    </div>
  );
};
